import { B as u } from "../../Button-CzIiGCVn.js";
import { a as w } from "../../Button-CzIiGCVn.js";
import { B as D } from "../../Button.skeleton-D0Onk1OP.js";
import { j as s, c as a } from "../../utils-BdNIfrGQ.js";
import { n as f } from "../../normalize-spacing-DY0KSpr_.js";
import { D as i } from "../../Div-spVpsZsH.js";
const c = (r, e) => e === 1 ? "" : r === 0 ? "rounded-r-none" : r === e - 1 ? "rounded-l-none" : "rounded-none", B = ({ buttons: r, spacing: e, size: n }) => {
  const l = n === "full" ? "w-full" : "w-fit";
  return /* @__PURE__ */ s.jsx(i, { className: a(f(e), "flex -space-x-px", l), children: r.map(({ className: m, ...o }, t) => /* @__PURE__ */ s.jsx(
    u,
    {
      className: a(
        m,
        "flex items-center gap-2 h-10",
        c(t, r.length)
      ),
      size: n,
      ...o,
      children: o.children
    },
    t
  )) });
};
export {
  w as Button,
  D as ButtonSkeleton,
  B as ButtonsGroup
};
